import React from 'react';
import PropTypes from 'prop-types';
import MainSection from './MainSection';
import TextInputField from './TextInputField';
import NonFieldErrorBanner from './NonFieldErrorBanner';

function ContactForm({
  fields,
  setField,
  validateField,
  nonFieldError,
  setNonFieldError,
  pressReleaseMetadata,
}) {
  return (
    <MainSection className="contact-information" title="Contact information">
      <p className="explanation-text" style={{ marginTop: '-16px', marginBottom: '1.5rem' }}>
        This information is not displayed with the press release and will be kept private.
      </p>
      <TextInputField
        key="submitter_name"
        id="submitter_name"
        label="Full name"
        isRequired
        onChange={setField}
        onBlur={validateField}
        value={fields.submitter_name.value}
        errorMsg={fields.submitter_name.errors}
        touched={fields.submitter_name.touched}
      />
      <TextInputField
        key="submitter_email"
        id="submitter_email"
        label="Email address"
        isRequired
        onChange={setField}
        onBlur={validateField}
        value={fields.submitter_email.value}
        errorMsg={fields.submitter_email.errors.slice(0, 1)}
        touched={fields.submitter_email.touched}
      />
      <TextInputField
        key="submitter_company"
        id="submitter_company"
        label="Company name"
        isRequired
        onChange={setField}
        onBlur={validateField}
        value={fields.submitter_company.value}
        errorMsg={fields.submitter_company.errors}
        touched={fields.submitter_company.touched}
      />
      <TextInputField
        key="submitter_title"
        id="submitter_title"
        label="Job title"
        onChange={setField}
        onBlur={validateField}
        value={fields.submitter_title.value}
        errorMsg={fields.submitter_title.errors}
        touched={fields.submitter_title.touched}
      />
      {nonFieldError && (
        <NonFieldErrorBanner
          setErrorCallback={setNonFieldError}
          prContactEmail={pressReleaseMetadata.pressrelease_contact_email}
        />
      )}
    </MainSection>
  );
}

const fieldShape = PropTypes.shape({
  value: PropTypes.string.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  touched: PropTypes.bool.isRequired,
});

ContactForm.propTypes = {
  fields: PropTypes.shape({
    submitter_name: fieldShape.isRequired,
    submitter_email: fieldShape.isRequired,
    submitter_company: fieldShape.isRequired,
    submitter_title: fieldShape.isRequired,
  }).isRequired,
  setField: PropTypes.func.isRequired,
  validateField: PropTypes.func.isRequired,
  nonFieldError: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]),
  setNonFieldError: PropTypes.func.isRequired,
  pressReleaseMetadata: PropTypes.shape({
    pressrelease_contact_email: PropTypes.string.isRequired,
  }).isRequired,
};

export default ContactForm;
